import React, { useEffect, useState } from "react";
import { useAuth } from "../../hooks";
export interface AuthAccessProps {
  children?: React.ReactNode;
}
export default function AuthAccess({ children }: AuthAccessProps) {
  const { getUserIsAuthenticated, authenticateByURL } = useAuth();
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    authenticateByURL().finally(() => setIsAuthenticating(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (isAuthenticating) {
    return <h2>Authenticating...</h2>;
  }

  if (!getUserIsAuthenticated()) {
    return <h2>User not authenticated</h2>;
  }
  return <>{children}</>;
}
